<template>
  <div class="container-fluid mt--12">
    <actions/>
    <div class="row">
      <div class="col-sm-12 col-lg-12">
        <lista/>
      </div>
    </div>
  </div>
</template>

<script>
import LinkUteisListaDetalhada from "./LinkUteisListaDetalhada";
import LinkUteisActions from "./LinkUteisActions";
export default {
  name: "LinkUteisContainerLista",
  components: {
    "lista": LinkUteisListaDetalhada,
    "actions": LinkUteisActions
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/linkUteis/LinkUteisContainerLista.vue